exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group label.control-label {\n    font-size: 14px;\n    line-height: 1.07143;\n    color: #AAAAAA;\n    font-weight: 600;\n    margin: 16px 0 0 0;\n}\n.card-header{\n    padding-left: 15px;\n}\n.card.my_card {\n    width: 25%;\n    display: inline-block;\n    float: left;\n}\n.my_card2 {\n    width: 75%;\n    display: inline-block;\n}\n\n.qa_container{\n    margin: 10px 0;\n    box-shadow: 0 0 1px;\n    background: #fff;\n}\n\n.like_button{\n    cursor: pointer;\n}\n\n.like_button label{\n    font-weight: 900 !important;\n    color: #000 !important;\n    margin :16px 0px 15px 0 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/user-survey/user-survey.component.css
// module id = ../../../../../src/app/dashboard/user-survey/user-survey.component.css
// module chunks = main